(() => {
  const qsa = (s, root = document) => Array.from(root.querySelectorAll(s));

  function initMenus(root = document) {
    qsa('[data-menu-open]', root).forEach((button) => {
      if (button.dataset.menuBound === 'true') return;
      button.dataset.menuBound = 'true';
      const id = button.getAttribute('data-menu-open');
      const drawer = document.getElementById(id);
      if (!drawer) return;

      const open = () => {
        drawer.hidden = false;
        requestAnimationFrame(() => drawer.classList.add('is-open'));
        button.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('menu-open');
        const firstFocusable = drawer.querySelector('button, a, summary');
        if (firstFocusable) firstFocusable.focus();
      };
      const close = () => {
        drawer.classList.remove('is-open');
        button.setAttribute('aria-expanded', 'false');
        document.documentElement.classList.remove('menu-open');
        window.setTimeout(() => { drawer.hidden = true; }, 220);
      };

      button.addEventListener('click', open);
      qsa('[data-menu-close]', drawer).forEach((el) => el.addEventListener('click', close));
      drawer.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          close();
          button.focus();
        }
      });
    });

    qsa('.mobile-nav details', root).forEach((details) => {
      if (details.dataset.detailsBound === 'true') return;
      details.dataset.detailsBound = 'true';
      details.addEventListener('toggle', () => {
        const marker = details.querySelector(':scope > summary span');
        if (marker) marker.textContent = details.open ? '−' : '+';
      });
    });
  }

  function initProductForms(root = document) {
    qsa('[data-variant-select]', root).forEach((select) => {
      if (select.dataset.variantBound === 'true') return;
      select.dataset.variantBound = 'true';
      select.addEventListener('change', () => {
        const option = select.options[select.selectedIndex];
        const form = select.closest('form');
        const price = document.querySelector('[data-product-price]');
        if (price && option && option.dataset.price) {
          const amount = Number(option.dataset.price) / 100;
          const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
          price.childNodes[0].textContent =
            new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency }).format(amount) + ' ';
        }
        const add = form && form.querySelector('.product-add');
        if (add) {
          add.disabled = option.disabled;
          add.textContent = option.disabled ? 'Sold out' : 'Add to cart';
        }
      });
    });
  }

  function initTheme(root = document) {
    initMenus(root);
    initProductForms(root);
  }

  initTheme(document);
  document.addEventListener('shopify:section:load', (event) => initTheme(event.target));
})();